import { Grid } from '@domain-group/suit-theme'

import { SavedArtworkPageModel, SavedArtworkModel } from '@models/types'

import SavedArtworkGridItem from '../../SavedArtworks/components/SavedArtworkGridItem'
import SavedArtworkPageGridItem from '../../SavedArtworkPages/components/SavedArtworkPageGridItem'

type GridViewProps = {
  entities: SavedArtworkPageModel[] | SavedArtworkModel[],
}

const GridView = (props: GridViewProps) => {
  const { entities } = props

  const Component = entities[0]?.type === 'SavedArtwork' ? SavedArtworkGridItem : SavedArtworkPageGridItem

  return (
    <Grid
      // @ts-expect-error TS2322
      gridGap="medium"
      gridAutoRows="1fr"
      gridTemplateColumns="repeat(auto-fill, minmax(250px, 1fr))"
      padding="large"
    >
      {entities.map(
        entity => <Component entity={entity} key={entity.id} />,
      )}
    </Grid>
  )
}

export default GridView
